import { render, staticRenderFns } from "./SimpleRiskAnalysisComponent.vue?vue&type=template&id=a6ed0856&scoped=true"
import script from "./SimpleRiskAnalysisComponent.vue?vue&type=script&lang=js"
export * from "./SimpleRiskAnalysisComponent.vue?vue&type=script&lang=js"
import style0 from "./SimpleRiskAnalysisComponent.vue?vue&type=style&index=0&id=a6ed0856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ed0856",
  null
  
)

export default component.exports